import React from "react";

const SubmitStory = () => {
  return <div>SubmitStory</div>;
};

export default SubmitStory;
